import stringify from 'qs-stringify'

export function fetchJson(url, { data = null, ...options } = {}) {
  return fetch(url, {
      headers: { 'Content-Type': 'application/json' },
      body: (data ? JSON.stringify(data) : ''),
      ...options
    })
    .then(response => response.json())
}

export function fetch_getJson(url, { data = null, ...options } = {}) {
  return fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options
  })
      .then(response => response.json())
}

export function action_fetch_getHTML(url, action_show, { data = null, ...options } = {}) {
  return fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options
  })
      .then(response => response.text())
      .then(data => {
        document.getElementById(action_show).innerHTML = data
      });
}

// Wrapper around the native Fetch API. Additional parameters:
//
//   * query – GET query parameters to include in the URL
export function fetch(url, { query = undefined, headers = {}, ...options } = {}) {
  const csrfTokenTag = document.getElementsByName('csrf-token')[0]

  if (csrfTokenTag) { // it will be missing in test mode
    headers['X-CSRF-Token'] = csrfTokenTag.content
  }

  if (query) {
    url = `${url}?${stringify(query)}`
  }

  return window.fetch(url, {
    headers: headers,
    credentials: 'same-origin', // send cookies for authentication
    ...options
  })
}
